// Persian / formatting helpers shared across client & server

const FA_DIGITS = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

/** Convert latin digits in a string to Persian digits */
export function toFa(input: string | number): string {
  return String(input).replace(/[0-9]/g, (d) => FA_DIGITS[Number(d)]);
}

/** Format a number with thousands separators (Persian digits) */
export function faNum(n: number): string {
  return toFa(n.toLocaleString("en-US"));
}

/** Format Toman amount, e.g. 165000 -> "۱۶۵,۰۰۰ تومان" */
export function faToman(toman: number): string {
  return `${faNum(toman)} تومان`;
}

/** Format card number with spaces every 4 digits */
export function formatCard(card: string): string {
  const digits = card.replace(/\D/g, "");
  return digits.replace(/(.{4})/g, "$1 ").trim();
}

/** Validate Iranian mobile: 09xxxxxxxxx */
export function isValidPhone(phone: string): boolean {
  return /^09\d{9}$/.test(phone.trim());
}

/** Validate Iranian bank card (16 digits) */
export function isValidCard(card: string): boolean {
  const d = card.replace(/\D/g, "");
  return d.length === 16;
}

/** Persian relative-ish date */
export function faDate(iso: string | Date): string {
  try {
    const d = typeof iso === "string" ? new Date(iso) : iso;
    return new Intl.DateTimeFormat("fa-IR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(d);
  } catch {
    return toFa(String(iso));
  }
}

export function faDateTime(iso: string | Date): string {
  try {
    const d = typeof iso === "string" ? new Date(iso) : iso;
    return new Intl.DateTimeFormat("fa-IR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(d);
  } catch {
    return toFa(String(iso));
  }
}

/** Days remaining until a date */
export function daysLeft(end: string | Date): number {
  const d = typeof end === "string" ? new Date(end) : end;
  const ms = d.getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
}
